// ========================================================
// ========xxxx======= Router Selectors ========xxxx=======
// ========================================================

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
export const selectRouter = createFeatureSelector<RouterReducerState>('router');

export const selectRouterState = createSelector(
  selectRouter,
  (activeRoute: RouterReducerState) => {
    return activeRoute.state;
  },
);
export const selectRouterUrl = createSelector(selectRouterState, (state) => {
  return state.url;
});
